import { ItemRewardType } from '@/cowboy/EnumTypes'
import * as getTypes from '@/store/get-types'
import * as mutationTypes from '@/store/mutation-types'
import * as actionTypes from '@/store/action-types'

const state = {
  longestScroll: 0
}

const getters = {
  [getTypes.GET_LONGEST_SCROLL]: ({ longestScroll }) => longestScroll,
  [getTypes.GET_FLATTENED_CATALOG_ITEM_TYPES]: (_, getters) => {
    const catalogItems = getters[getTypes.GET_CATALOG_ITEMS]
    const itemTypes = new Set()

    for (const item of Object.values(catalogItems)) {
      if (item.rewardType?.description) {
        itemTypes.add(item.rewardType.description)
      }
    }

    return {
      catalog_has_ach: itemTypes.has(ItemRewardType.PAYMENT_ACH),
      catalog_has_push_to_card: itemTypes.has(ItemRewardType.PAYMENT_DEBIT_CARD),
      catalog_has_both_cash_items: itemTypes.has(ItemRewardType.PAYMENT_ACH) &&
        itemTypes.has(ItemRewardType.PAYMENT_DEBIT_CARD)
    }
  },
  [getTypes.ORDER_TRACKING_PROPERTIES]: (_, getters) => {
    return {
      ...getters[getTypes.GET_FLATTENED_CATALOG_ITEM_TYPES],
      products: getters[getTypes.GET_CART_ITEMS_FORMATTED_AS_PRODUCTS],
      currency: getters[getTypes.GET_CURRENCY_CODE],
      total: getters[getTypes.GET_CART_TOTAL]
    }
  }
}

const actions = {
  [actionTypes.UPDATE_LONGEST_SCROLL]: ({ getters, commit }, currentScroll) => {
    if (currentScroll > getters[getTypes.GET_LONGEST_SCROLL]) {
      commit(mutationTypes.SET_LONGEST_SCROLL, currentScroll)
    }
  }
}

const mutations = {
  [mutationTypes.SET_LONGEST_SCROLL]: (state, longestScroll) => {
    state.longestScroll = longestScroll
  }
}

export default { state, getters, actions, mutations }
